export default __webpack_public_path__ + "static/media/tabler-icon-check.95b1f32b.svg";